<template>
  <div class="NewsShow">
    <div style="width: 980px;margin: auto;">
      <div class="title-box" v-html="title"></div>
      <!--      <el-button type="success" @click="admit">提交</el-button>-->
      <div class="date-box">发布时间：{{date}}</div>
      <div v-html="content" class="details-box" ></div>
    </div>
  </div>
</template>

<script>
import time from "@/core/time";
import {ElLoading} from "element-plus";
export default {
  created() {
  },
  mounted() {
    this.id = this.$route.query.id;
    this.filter();
  },
  data(){
    return{
      id:null,
      date:'',
      content:'',
      title:'',
      fileList:[],
    }
  },
  methods:{
    filter(){
      let data = {
        id:this.id,
        lang:this.$i18n.locale,
      }
      let loadingInstance = null;
      loadingInstance = ElLoading.service({ fullscreen: true});
      this.$request.post('/ArAnnounce/selectAnnounce',data).then(data => {
        console.log("filter");
        console.log(data);
        this.title =  data.obj.announce.title;
        this.content = data.obj.announce.content;
        this.date = time.formateDate(data.obj.announce.createdDate);
        loadingInstance.close();
      })
    },
  }
}
</script>

<style lang="less">
.NewsShow{
  width: 100%;
  height: 100%;
  a:link {color: black; text-decoration:none;} //未访问
  a:active {color: black; } //激活：红色
  a:visited {color:black;text-decoration:none;} //已访问
  a:hover {color: black; text-decoration:underline;} //鼠标移近
  .btn-back{
    border: none;
    font-size: 16px;
  }
  .title-box{
    text-align: center;
    font-size: 20px;
    margin: 60px 0 30px 0;
    font-weight: 800;
  }
  .date-box{
    font-size: 16px;
    color: #777777;
    text-align: center;
    padding-bottom: 48px;
  }
  .details-box{
    margin-top: 25px;
    font-size: 16px;
    line-height: 25px;
    text-align: left;
    img{
      align:center;
      max-width: 100%;
      max-height: 700px;
    }

  }
  .file-box{
    margin-top: 40px;
    padding-bottom: 50px;
  }
}
</style>
